import { TextManager } from "Components/TextContext";
import { AdviceCoverageName } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { AkaGroupLifeCoverage } from "Store/interfaces/products/coverage";
import { humanReadableDate } from "Utils/dateUtils";
import { isDefined } from "Utils/functions";
import React from "react";
import ReactMarkdown from "react-markdown";
import { MarkdownWrapper } from "../styled";

interface Props {
  coverageGroup: AdviceCoverageName;
}

export const AkaGroupLifeCoverageInfo = ({
  coverageGroup,
}: Props): React.ReactElement | null => {
  const coverageText = getCoverageText(coverageGroup);

  if (!isDefined(coverageText)) {
    return null;
  }

  return (
    <MarkdownWrapper>
      <ReactMarkdown>{coverageText}</ReactMarkdown>
    </MarkdownWrapper>
  );
};

const getCoverageText = (
  coverageGroup: AdviceCoverageName,
): string | undefined => {
  const { getText } = TextManager;
  switch (coverageGroup) {
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH:
      return getText("akaadvicepage.termsanddetails.akagrouplifedeath");
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP:
      return getText("akaadvicepage.termsanddetails.akagrouplifeincap");
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME:
      return getText("akaadvicepage.termsanddetails.akagrouplifetime", {
        variables: { date: humanReadableDate(new Date()) },
      });
    default:
      return undefined;
  }
};
